<form>
  <mat-form-field>
    <mat-label>{{ inputLabel }}</mat-label>
    <mat-chip-grid
      #chipGrid
      aria-label="Select values"
      [formControl]="control">
      <mat-chip-row
        *ngFor="let value of values"
        [aria-description]="'press enter to edit ' + value"
        [editable]="true"
        [highlighted]="value == selectedValue"
        (edited)="edit(value, $event)"
        (removed)="remove(value)"
        (click)="select(value)">
        {{ value }}
        <button
          matChipRemove
          [attr.aria-label]="'remove ' + value">
          <mat-icon class="material-symbols-rounded">close</mat-icon>
        </button>
      </mat-chip-row>
      <input
        matInput
        type="text"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="add($event)" />
    </mat-chip-grid>
    <mat-error *ngIf="control.hasError('required')">This is required</mat-error>
    <mat-error *ngIf="control.hasError('custom')">{{ control.getError('custom') }}</mat-error>
  </mat-form-field>
  <div
    *ngIf="selectionEnabled"
    class="input-hint">
    Click on an option to make it a default answer
  </div>
</form>
